import styled, { css } from 'styled-components';

export const StepsWrapper = styled.div<{ variant: 'vertical' | 'horizontal' }>`
  display: flex;
  padding: 2px 0;
  box-sizing: border-box;
  ${({ variant }) =>
    variant === 'vertical' &&
    css`
      flex-direction: column;
    `};
`;
